module.exports = __webpack_public_path__ + "img/837-a463c6.png";